$(document).ready(function() {
  var choices = document.querySelectorAll('label.variant-option__button-label');
  var maxWidth = 0;
  // read
  for (var i = 0; i < choices.length; ++i) {
      maxWidth = Math.max(maxWidth, choices[i].offsetWidth)
  };

  // write
  for (var i = 0; i < choices.length; ++i) {
      choices[i].style.width = maxWidth + "px";
  }; 
})

$(document).on('click', '.product-information__grid label.variant-option__button-label', function(event) {
    var vl = $(this).find('input').attr('value');
    $('.product-information__grid .arne-color-swatch-element').removeClass('disabled_div');
    $('.product-information__grid .arne-color-swatch-element').each(function() {
      var x = JSON.parse($(this).find('script').html());
      var that = $(this);
      var vav = false;
    
      var hr = that.attr('rel_handle');
      x.forEach(function(v, i) {
        if (v.option1 == vl || v.option2 == vl || v.option3 == vl) {
          if (v.available) {} else {
            that.addClass('disabled_div');
          }
          vav = true;
          if (that.hasClass('active')) {} else {
            var hrl = hr+'?variant='+v.id;

            if (vl == v.title) {
              that.find('a').attr('href', hrl);
            }
          }
        }
      });
      if (vav) {
      } else {
        that.addClass('disabled_div');
      }
    });
});

$(document).on('click', 'h4.facets--filters-title', function() {
  $(this).toggleClass('active');
  $('.facets-block-wrapper.facets-block-wrapper--vertical').slideToggle();
});


// UPDATED JS - KEEP BUTTON ACTIVE WHEN SHEET OPEN
// class HorizonQuickAddOptions {
//   constructor() {
//     this.sheets = document.querySelectorAll('[data-quick-add-sheet]');
//     this.triggers = document.querySelectorAll('[data-product-card-quick-add]');
//     this.init();
//   }
  
//   init() {
//     // **IMPROVED TRIGGER HANDLING**
//     this.triggers.forEach(trigger => {
//       trigger.addEventListener('click', (e) => {
//         e.stopPropagation();
//         e.preventDefault();
//         this.openSheet(trigger);
//       });
//     });
    
//     this.sheets.forEach(sheet => {
//       const overlay = sheet.querySelector('[data-sheet-overlay]');
//       const closeBtn = sheet.querySelector('[data-sheet-close]');
      
//       overlay?.addEventListener('click', () => this.closeSheet(sheet));
//       closeBtn?.addEventListener('click', () => this.closeSheet(sheet));
//       this.initSwipeClose(sheet);
      
//       // **FIXED RADIO BUTTONS**
//       sheet.addEventListener('change', (e) => {
//         if (e.target.matches('input[type="radio"]')) {
//           this.updateVisualSelection(e.target);
//           this.updateSubmitButton(sheet);
//         }
//       });
      
//       sheet.querySelectorAll('.option-value').forEach(label => {
//         label.addEventListener('click', (e) => {
//           const radio = label.querySelector('input[type="radio"]');
//           if (radio) {
//             radio.checked = true;
//             radio.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         });
//       });
//     });
//   }
  
//   openSheet(trigger) {
//     const sheet = trigger.closest('.product-card-quick-add')?.querySelector('[data-quick-add-sheet]');
//     if (!sheet) return;
    
//     // **NEW: ADD ACTIVE CLASS TO BUTTON**
//     trigger.classList.add('active');
    
//     // Close others
//     document.querySelectorAll('.quick-add-sheet.active').forEach(s => {
//       if (s !== sheet) this.closeSheet(s);
//     });
//     document.querySelectorAll('.quick-add-trigger.active').forEach(t => {
//       if (t !== trigger) t.classList.remove('active');
//     });
    
//     sheet.classList.add('active');
//     // document.body.style.overflow = 'hidden';
//     this.updateSubmitButton(sheet);
//   }
  
//   closeSheet(sheet) {
//     sheet.classList.remove('active');
//     document.body.style.overflow = '';
    
//     // **NEW: REMOVE ACTIVE CLASS FROM BUTTON**
//     const trigger = document.querySelector('[data-product-card-quick-add]');
//     if (trigger) trigger.classList.remove('active');
//   }
  
//   // ... rest of methods unchanged (updateVisualSelection, initSwipeClose, updateSubmitButton)
//   updateVisualSelection(radio) {
//     const parentGroup = radio.closest('.option-values');
//     parentGroup.querySelectorAll('.option-value').forEach(item => {
//       // item.style.background = 'var(--color-background)';
//       // item.style.borderColor = 'var(--color-border)';
//       // item.style.color = '';
//     });
    
//     const selectedLabel = radio.closest('.option-value');
//     selectedLabel.style.background = 'var(--color-foreground)';
//     selectedLabel.style.borderColor = 'var(--color-foreground)';
//     selectedLabel.style.color = 'var(--color-background)';
//   }
  
//   initSwipeClose(sheet) {
//     let startY = 0;
//     let startTime = 0;
//     const container = sheet.querySelector('.sheet-container');
    
//     container.addEventListener('touchstart', (e) => {
//       startY = e.touches[0].clientY;
//       startTime = Date.now();
//     });
    
//     container.addEventListener('touchmove', (e) => {
//       const currentY = e.touches[0].clientY;
//       const deltaY = currentY - startY;
//       if (deltaY > 50 && Date.now() - startTime < 500) {
//         this.closeSheet(sheet);
//       }
//     });
//   }
  
//   updateSubmitButton(sheet) {
//     const submitBtn = sheet.querySelector('[data-submit-button]');
//     const variantPicker = sheet.querySelector('.sheet-variant-picker');
    
//     if (submitBtn && variantPicker) {
//       const selectedVariant = variantPicker.querySelector('input:checked, select option:checked');
//       const variantPrice = selectedVariant?.dataset?.price || 
//                           sheet.querySelector('.sheet-price')?.textContent?.trim();
      
//       submitBtn.textContent = variantPrice ? `Add ${variantPrice}` : 'Add to cart';
//     }
//   }
// }

// // Initialize
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => new HorizonQuickAddOptions());
// } else {
//   new HorizonQuickAddOptions();
// }

// $('button.quick-add-trigger.btn-unstyled').click(function() {
//     $(this).parents('.card-gallery').find('button.button.quick-add__button').trigger('click')
// })
// $(document).on('click', 'label.option-value', function() {
//   var id = $(this).attr('product_option_id');
//   console.log(id)
//   $('.variant-option__button-label input[data-option-value-id="'+id+'"]').parent().trigger('click');
// })

class HorizonQuickAddOptions {
  constructor() {
    this.productData = {};
    this.init();
    this.initObserver();
  }

init() {
    // We use the Capture Phase (true) so your script intercepts the click 
    // BEFORE any theme listeners or navigation events can trigger.
    document.addEventListener('click', (e) => {
      
      // 1. Handle Trigger
      const trigger = e.target.closest('[data-product-card-quick-add]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Prevents theme-level listeners from seeing this
        this.openSheet(trigger);
        return;
      }

      // 2. Handle Close
      const closeBtn = e.target.closest('[data-sheet-close]');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.closeSheet(closeBtn.closest('[data-quick-add-sheet]'));
        return;
      }

      // 3. Handle Submit
      const submitBtn = e.target.closest('[data-submit-button]');
      if (submitBtn) {
        // ESSENTIAL: Stop ALL event propagation to prevent redirect
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const sheet = submitBtn.closest('[data-quick-add-sheet]');
        const parent = sheet.closest('.product-card-quick-add');
        if (parent?.dataset.product) {
          this.handleAddToCart(sheet, parent.dataset.product);
        }
        return false; // Final guard against default browser behavior
      }
    }, true); 

    // 4. Visual Selection logic
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        this.updateVisualSelection(e.target);
      }
    });
  }

  // Watches for new dynamically injected products
  initObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector('[data-product-card-quick-add]')) {
            this.loadProductData(node.querySelector('.product-card-quick-add'));
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Initial scan for static content
    document.querySelectorAll('.product-card-quick-add').forEach(card => this.loadProductData(card));
  }

  loadProductData(parentContainer) {
    const productId = parentContainer.dataset.product;
    const productHandle = parentContainer.dataset.handle;
    
    if (productHandle && !this.productData[productId]) {
      fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(data => { this.productData[productId] = data; })
        .catch(err => console.error("QuickAdd JSON error:", err));
    }
  }

  openSheet(trigger) {
    const sheet = trigger.closest('.product-card-quick-add')?.querySelector('[data-quick-add-sheet]');
    if (!sheet) return;
document.querySelectorAll('.resource-list__slide').forEach(slide => {
        slide.classList.remove('quick-add-open');
    });
    const parentSlide = trigger.closest('.resource-list__slide'); 

    if (parentSlide) {
        parentSlide.classList.add('quick-add-open');
    }



document.querySelectorAll('.product-grid__item').forEach(slide => {
        slide.classList.remove('quick-add-open');
    });
    const parentSlideColl = trigger.closest('.product-grid__item'); 

    if (parentSlideColl) {
        parentSlideColl.classList.add('quick-add-open');
    }


    

    // Fix: Explicitly remove 'active' from all other sheets before opening
    document.querySelectorAll('[data-quick-add-sheet]').forEach(s => s.classList.remove('active'));
    document.querySelectorAll('[data-product-card-quick-add]').forEach(t => t.classList.remove('active'));

    // Apply active class
    trigger.classList.add('active');
    sheet.classList.add('active');
  }

  closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('active');
    const trigger = sheet.closest('.product-card-quick-add')?.querySelector('[data-product-card-quick-add]');
    if (trigger) trigger.classList.remove('active');
  }

async handleAddToCart(sheet, productId) {
    const submitBtn = sheet.querySelector('[data-submit-button]');
    const parentContainer = sheet.closest('.product-card-quick-add');
    const productHandle = parentContainer.dataset.handle;

    // 1. Force fetch if productData is missing
    if (!this.productData[productId]) {
      submitBtn.innerText = "Loading...";
      try {
        const response = await fetch(`/products/${productHandle}.js`);
        this.productData[productId] = await response.json();
      } catch (e) {
        console.error("Failed to load product data on click", e);
        return;
      }
    }

    const product = this.productData[productId];
    const selectedRadio = sheet.querySelector('input[type="radio"]:checked');
    
    if (!selectedRadio) return alert("Please select an option.");

    // Now product is guaranteed to exist
    const selectedOptions = Array.from(sheet.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
    const variant = product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));

    if (!variant || !variant.available) return;

    submitBtn.disabled = true;
    submitBtn.innerText = "Adding...";

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'items': [{ 'id': variant.id, 'quantity': 1 }] })
      });
// 2. LOG THE STATUS: Catch that "unknown" or error status
      if (!response.ok) {
        console.error("Cart API failed with status:", response.status, response.statusText);
        // Do NOT let the browser redirect!
        alert("Sorry, we couldn't add that item. Please try again.");
        return; 
      }

      if (response.ok) {
        const cart = await response.json();
        this.closeSheet(sheet);
console.log(cart, 'fdsfdfdfdfdfd')

// Ensure you are dispatching the object the theme expects
const cartData = await fetch('/cart.js').then(res => res.json());

        document.dispatchEvent(new CustomEvent('cart:update', { 
          bubbles: true, 
          detail: { data: { item_count: cartData.item_count, items: cart.items } } 
        }));

// Dispatch the event using the structure Horizon components listen for
document.dispatchEvent(new CustomEvent('cart:update', {
  bubbles: true,
  detail: {
    resource: cartData,
    sourceId: 'custom-quick-add', // Label this as your own
    data: {
      itemCount: cartData.item_count,
      source: 'product-form-component' // Mimic the native source so the theme doesn't ignore it
    }
  }
}));

        

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          else drawer.setAttribute('open', '');
        }
      }
    } catch (err) {
      console.error("Cart Error:", err);
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerText = "Add to basket";
    }
  }

  updateVisualSelection(radio) {
    const parentGroup = radio.closest('.option-values');
    if (!parentGroup) return;
    parentGroup.querySelectorAll('.option-value').forEach(label => {
      label.style.background = '';
      label.style.color = '';
    });
    const label = radio.closest('.option-value');
    if (label) {
      label.style.background = 'var(--color-foreground)';
      label.style.color = 'var(--color-background)';
    }
  }
}

// A single, safe initialization method
const initQuickAdd = () => {
  if (!window.horizonQuickAdd) {
    window.horizonQuickAdd = new HorizonQuickAddOptions();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuickAdd);
} else {
  initQuickAdd();
}

$('.maebe-faq .accordion').click(function() {
  $(this).toggleClass('active');
  $(this).next().slideToggle();
});

document.addEventListener('click', function(event) {
    const swatch = event.target.closest('.quick_add_colour');
    if (!swatch) return;

    event.preventDefault();

    // 1. Get the target URL for the new variant
    const variantUrl = swatch.querySelector('a').getAttribute('href');
    
    // 2. Fetch the new HTML using the Sections Rendering API
    // Ensure you target the specific section ID of your product card

    if (swatch.classList.contains('is_ww_true')) {
      fetch(`${variantUrl}?section_id=ww-card-section-id`)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCard = doc.querySelector('.ww-card');
            
            // 3. Replace the existing card with the new one
            const currentCard = swatch.closest('.ww-card');
            if (currentCard) {
              currentCard.parentNode.replaceChild(newCard, currentCard);
            }

            // --- RE-INITIALIZE THEME JS ---
            // Most modern themes have a global function to re-bind events
            if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
                theme.init(); 
            } 
            // OR, if your theme uses custom elements (like Dawn/Horizon)
            // you may need to trigger the browser to re-detect the custom element:
            document.querySelectorAll('.quick-add__submit').forEach(btn => {
                // This forces any existing listeners to re-attach if they are delegated
                btn.dispatchEvent(new Event('mouseover')); 
            });
        })
        .catch(error => console.error('Error updating product card:', error));
      } else {
        
      fetch(`${variantUrl}?section_id=product-card-section-id`)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCard = doc.querySelector('.product-card');
            
            // 3. Replace the existing card with the new one
            const currentCard = swatch.closest('.product-card');
            if (currentCard) {
              currentCard.parentNode.replaceChild(newCard, currentCard);
            }

            // --- RE-INITIALIZE THEME JS ---
            // Most modern themes have a global function to re-bind events
            if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
                theme.init(); 
            } 
            // OR, if your theme uses custom elements (like Dawn/Horizon)
            // you may need to trigger the browser to re-detect the custom element:
            document.querySelectorAll('.quick-add__submit').forEach(btn => {
                // This forces any existing listeners to re-attach if they are delegated
                btn.dispatchEvent(new Event('mouseover')); 
            });
        })
        .catch(error => console.error('Error updating product card:', error));
      }
});



/**
 * Function to hide out-of-stock products after a filter is applied
 */function handleOutOfStockVisibility() {
    const activeFilters = new URLSearchParams(window.location.search);
    // Check for standard Shopify filter parameters
    const hasActiveFilters = Array.from(activeFilters.keys()).some(key => 
        key.startsWith('filter.v.') || key.startsWith('filter.p.')
    );

    const productCards = document.querySelectorAll('.product-grid__item');

    productCards.forEach(card => {
        // IMPROVED DETECTION:
        // 1. Check data attribute 2. Check for a 'sold out' class 3. Check for badge text
        const isOutOfStock = 
            card.dataset.available === 'false' || 
            card.classList.contains('is-sold-out') || 
            card.querySelector('.badge--sold-out, .badge--out-of-stock') !== null;

        if (hasActiveFilters) {
            if (isOutOfStock) {
                card.style.setProperty('display', 'none', 'important');
            } else {
                card.style.setProperty('display', 'block', 'important');
            }
        } else {
            // Show everything on initial load/no filters
            card.style.setProperty('display', 'block', 'important');
        }
    });
}

// 1. Listen for the theme's specific events
// Horizon sometimes uses 'collection:reloaded' or 'facet:changed'
['collection:reloaded', 'facet:changed', 'view:change'].forEach(eventName => {
    document.addEventListener(eventName, handleOutOfStockVisibility);
});

// 2. Mutation Observer fallback 
// This triggers even if the event name is wrong
const gridContainer = document.querySelector('#ProductGridContainer'); // Adjust ID if needed
if (gridContainer) {
    const observer = new MutationObserver(() => {
        handleOutOfStockVisibility();
    });
    observer.observe(gridContainer, { childList: true, subtree: true });
}

const ResultsList = document.querySelector('#ResultsList'); // Adjust ID if needed
if (ResultsList) {
    const observer = new MutationObserver(() => {
        handleOutOfStockVisibility();
    });
    observer.observe(ResultsList, { childList: true, subtree: true });
}



// 3. Run once on page load
handleOutOfStockVisibility();


document.addEventListener('change', function(event) {
    const select = event.target.closest('sticky-add-to-cart .variant-option__select-wrapper select');
    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];
    const selectedVariant = selectedOption.getAttribute('data-variant-id');

    if (selectedVariant) {
        const mainInput = document.querySelector(`.variant-picker__form label.variant-option__button-label input[data-variant-id="${selectedVariant}"]`);
        
        if (mainInput && mainInput.parentElement) {
            // 1. Get current scroll position
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

            // 2. Lock the scroll position
            window.onscroll = function() {
                window.scrollTo(scrollLeft, scrollTop);
            };

            // 3. Trigger the theme's logic
            mainInput.parentElement.click();

            // 4. Release the lock after the theme finishes its jump logic
            setTimeout(() => {
                window.onscroll = null;
            }, 500); // 500ms is usually enough to catch the theme's animation
        }

        const stickyContainer = document.querySelector('sticky-add-to-cart.sticky-add-to-cart');
        if (stickyContainer) {
            stickyContainer.setAttribute('data-current-variant-id', selectedVariant);
        }
    }
});

document.addEventListener('click', function(event) {
  // 1. Check if the clicked element matches your sticky button selector
  const stickyBtn = event.target.closest('button.sticky-add-to-cart__button.button');
  
  if (stickyBtn) {
    event.preventDefault();
    event.stopPropagation();

    // 2. Find the main "Add to Cart" button using the [ref] attribute
    const mainAddToCartBtn = document.querySelector('.add-to-cart-button[ref="addToCartButton"]');

    if (mainAddToCartBtn) {
      // 3. Programmatically trigger the click on the main button
      mainAddToCartBtn.click();
    }
  }
});


document.addEventListener('click', (e) => {
  // 1. Check if the clicked element is a link inside your metafield class
  const link = e.target.closest('.metafield-rich_text_field a');
  if (!link) return;

  const hrefValue = link.getAttribute('href');

  // 2. Check if the href is JUST a number (e.g., "1", "2")
  if (/^\d+$/.test(hrefValue)) {
    // STOP the redirection immediately
    e.preventDefault();
    e.stopImmediatePropagation();

    const targetIndex = parseInt(hrefValue, 10) - 1;
    const gallery = document.querySelector('media-gallery');

    if (gallery && gallery.slideshow) {
      console.log('Scrolling to image index:', targetIndex);
      gallery.slideshow.select(targetIndex, null, { animate: true });
      
      // Optional: Smoothly scroll the whole screen to the gallery 
      // so the user actually sees the image change
      gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.error('Media gallery or slideshow not found on this page.');
    }
  }
}, true); // Use 'true' for capturing phase to beat the theme's default links


document.addEventListener('DOMContentLoaded', () => {
  const colorLinks = document.querySelectorAll('.swatch_e[hover_featured_image]');

  colorLinks.forEach(link => {
    const card = link.closest('product-card');
    if (!card) return;

    const hoverImgUrl = link.getAttribute('hover_featured_image');
    // Find the primary image (usually the first slide)
    const targetImg = card.querySelector('.product-media__image');

    const handleHover = (e) => {
      if (targetImg && hoverImgUrl) {
        // Save original state
        if (!targetImg.dataset.originalSrc) {
          targetImg.dataset.originalSrc = targetImg.src;
          targetImg.dataset.originalSrcset = targetImg.srcset;
        }
        targetImg.src = hoverImgUrl;
        targetImg.srcset = '';
      }
    };

    const resetHover = () => {
      if (targetImg && targetImg.dataset.originalSrc) {
        targetImg.src = targetImg.dataset.originalSrc;
        targetImg.srcset = targetImg.dataset.originalSrcset;
      }
    };

    // Desktop Hover
    link.addEventListener('mouseenter', handleHover);
    link.addEventListener('mouseleave', resetHover);

    // Mobile Fix: Prevent redirection on the first tap
    link.addEventListener('click', function(e) {
      // Check if this specific link was already "active"
      if (!this.classList.contains('is-active')) {
        e.preventDefault(); // Stop the redirect
        
        // Reset all other links in this card
        card.querySelectorAll('.swatch_e').forEach(l => l.classList.remove('is-active'));
        
        // Show the hover image
        handleHover();
        
        // Mark this one as active so the NEXT click works
        this.classList.add('is-active');
      }
    });
  });

  // Reset image if user taps anywhere else on the screen
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.swatch_e')) {
      document.querySelectorAll('.swatch_e.is-active').forEach(link => {
        link.classList.remove('is-active');
        // Logic to reset image could go here if needed
      });
    }
  });

document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.swatch_e');
  
  if (swatch) {
    e.preventDefault();
    e.stopPropagation();

    // Lookbook mode: colourways must not link through either.
    if (swatch.closest('.product-card--no-link')) return;

    const url = swatch.getAttribute('data-url');
    if (url) {
      window.location.href = url;
    }
  }
});
});